import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLastVisitedPage } from '../redux/slice/navigationSlice';
import { RootState } from '../redux/store';

export const useNavigationHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lastVisitedPage = useSelector((state: RootState) => state.navigation.lastVisitedPage);

  useEffect(() => {
    // Only update last visited page if we're changing paths
    if (location.pathname !== lastVisitedPage) {
      dispatch(setLastVisitedPage(location.pathname));
    }
  }, [location.pathname, dispatch, lastVisitedPage]);

  const handleBack = () => {
    if (lastVisitedPage && lastVisitedPage !== location.pathname) {
      navigate(lastVisitedPage);
    } else {
      navigate(-1); // Fallback to browser history
    }
  };

  return {
    handleBack,
    canGoBack: !!lastVisitedPage && lastVisitedPage !== location.pathname,
  };
}; 